import config from '../config';
import _ from 'lodash';

class ApiClient {

    constructor() {
        this.baseUrl = config.apiBaseURL + "/api/v1";
    }

    get(path) {
        return this.request({
            path: path,
            method: 'GET'
        });
    }

    post(path, body) {
        return this.request({
            path: path,
            method: 'POST',
            body: body
        });
    }

    request(options) {
        let method = options.method || 'GET';
        let path = options.path;
        let body = options.body || null;
        let file = options.file || null;
        let query = options.query || null;
        let url = this.baseUrl + path + this.queryString(query);

        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();

            function handleError() {
                let response = xhr.response;
                if (response && response['errors'] && response['errors'][0]) {
                    reject(new Error(response['errors'][0].message));
                } else if (xhr.statusText) {
                    reject(new Error(xhr.statusText));
                } else {
                    reject(new Error('Could not fetch response (' + method + ' ' + path + ') due to a network error.'));
                }
            }

            xhr.open(method, url);
            xhr.responseType = 'json';
            xhr.onload = function() {
                if (xhr.readyState === 4) {
                    let response = xhr.response;
                    if (xhr.status === 200) {
                        resolve(response);
                    } else {
                        handleError();
                    }
                }
            };
            xhr.onerror = handleError;
            xhr.onabort = handleError;
            xhr.withCredentials = true;
            if (body) {
                xhr.setRequestHeader('Content-Type', 'application/json');
                body = JSON.stringify(body);
            } else if (file) {
                body = new FormData();
                body.append('file', file);
            }
            xhr.send(body);
        });
    }

    queryString(query) {
        if (!query) {
            return '';
        }
        return _.reduce(query, (qs, value, key) => {
            return qs + (qs ? '&' : '?') + encodeURIComponent(key) + '=' + encodeURIComponent(value);
        }, '');
    }

    currentUser() {
        return this.get('/currentUser');
    }

    login(email, password) {
        return this.post('/login', {
            email: email,
            password: password
        });
    }

    register(email, password) {
        return this.post('/register', {
            email: email,
            password: password
        });
    }

    forgotPassword(email) {
        return this.post('/forgotPassword', {
            email: email
        });
    }

    resetPassword(password, resetPasswordToken) {
        return this.post('/resetPassword', {
            password: password,
            resetPasswordToken: resetPasswordToken
        });
    }

    logout() {
        return this.get('/logout');
    }

}

export default new ApiClient();



// WEBPACK FOOTER //
// ./src/services/taskboardApiClient.js